import { FormActions } from "../../components/common/FormActions";
import { TTableColumn } from "../../types/common";
import { createViewEdit, numberFormat } from "../../utils/helpers";
import RegisterLayoutHandler from "../../components/layouts/RegisterLayoutHandler";
import { API_PRODUCTS } from "../../utils/apis";

export const usePurchaseOrderItems = () => {
  const tableColumns = (): TTableColumn[] => [
    { id: "purchase_order_number", header: "Order Number" },
    { id: "supplier_name", header: "Supplier" },
    { id: "purchase_order_date", header: "Purchase Order Dater" },
    { id: "payment_type", header: "Payment Type" },
    { id: "total_amount", header: "Total Amount" },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      actions: (
        <FormActions
          actions={createViewEdit("/purchase_order_inventory", item?.id)}
        />
      ),
    }));

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Order Information",
          fields: {
            terms_of_payment: item?.terms_of_payment,
            description: item?.description,
            quantity: item?.quantity,
            quantity_recieved: item?.quantity_recieved || "0",
            unit_price: numberFormat(item?.unit_price),
            total_price: numberFormat(item?.total_price),
          },
        },
        {
          title: "Inventory Information",
          fields: {
            name: item?.inventory?.name,
            quantity: item?.inventory?.quantity,
            vehicle_type_name: item?.inventory?.vehicle_type_name,
            description: item?.description,
          },
        },
        {
          title: "Products Recieved Details",
          fields: {},
          component: (
            <RegisterLayoutHandler
              source_id={"products"}
              api={`${API_PRODUCTS}?inventory=${item?.inventory?.id}&purchase_order_inventory=${item?.id}`}
              title="Items Details"
              fullWidth={false}
            />
          ),
        },
      ],
    };
  };

  return { tableColumns, tableData, viewData };
};
